export default __webpack_public_path__ + "static/founders-grotesk-web-regular-03da8f78b8d484b68647702e8610b1cb.woff2";